import React from "react";
import classNames from "classnames";
import { Label } from "lib/components/vendor";
import { OrderDecorator } from "lib/decorators";

const colors = {
  building: undefined,
  waiting_for_customer_approval: "olive",
  waiting_for_company_approval: "yellow",
  approved: "green",
  finished: "blue",
  rejected: "red",
  cancelled: "purple",
  abandoned: "black",
};
export default function OrderStatusLabel({ status, className, shortLabel, ...props }) {
  const color = colors[status];
  return (
    status && (
      <Label
        {...props}
        className={"u-textOverflow " + className || ""}
        color={color}
        content={OrderDecorator.getStatusLabel(status, shortLabel)}
      />
    )
  );
}



// WEBPACK FOOTER //
// ./src/lib/components/OrderStatusLabel.jsx